import { set } from 'lodash'
import { IContactBase } from 'features/Contacts/types'

export const csvToContacts = (csv: string): IContactBase[] => {
  const result = []
  const [header, ...lines] = csv.split(/\r?\n/).map(line => line.split(','))
  header.forEach((key, headerIdx) => {
    lines.forEach((line, lineIdx) => {
      set(result, `[${lineIdx}]${key}`, line[headerIdx])
    })
  })
  return result as any
}



// WEBPACK FOOTER //
// src/features/Contacts/utils/csvToContacts.ts